<script setup lang="ts">
import type { Component } from "vue";
import List from "./components/List.vue";
import Manager from "./components/Manager.vue";
import Chat from "./components/Chat.vue";
const activeComponentName = ref("List");

const components: Record<string, Component> = {
	Chat,
	List,
	Manager,
};
</script>

<template>
	<component :is="components[activeComponentName]" v-model="activeComponentName" />
</template>
